var map = {
	"./de/index.json": [
		892,
		2
	],
	"./en-GB/index.json": [
		893,
		3
	],
	"./es/index.json": [
		894,
		4
	],
	"./fr-FR/index.json": [
		895,
		5
	],
	"./nl/index.json": [
		896,
		6
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 873;
module.exports = webpackAsyncContext;